export default "__VITE_ASSET__716e7766__"